/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SectionBrandmanagerQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type SectionBrandmanagerQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    userEntityPages?: {
      __typename?: 'UserEntityPages';
      collection: Array<{
        __typename?: 'EntityPage';
        publicationStatus: Types.EntityPagePublicationStatus;
        focusType?: Types.EntityPageFocusType | null;
      } | null>;
    } | null;
    teamPermissions?: {
      __typename?: 'TeamPermissionsViewer';
      userResources?: {
        __typename?: 'TeamPermissionsResourceRights';
        collection?: Array<{
          __typename?: 'TeamPermissionsResourceRight';
          permissions: Array<string>;
          resourceId: string;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export const SectionBrandmanagerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SectionBrandmanager' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userEntityPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'publicationStatus',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'focusType' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teamPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userResources' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'permissions' },
                            value: {
                              kind: 'StringValue',
                              value: 'manage_users',
                              block: false,
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'resourceType' },
                            value: { kind: 'EnumValue', value: 'PAGES' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'types' },
                            value: {
                              kind: 'StringValue',
                              value: 'company',
                              block: false,
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'collection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'permissions',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceId' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SectionBrandmanagerQuery,
  SectionBrandmanagerQueryVariables
>;
